import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPointLeftCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 24C0 37.234 10.766 48 24 48C37.234 48 48 37.234 48 24C48 10.766 37.234 0 24 0C10.766 0 0 10.766 0 24ZM17.172 24L28 13.172L30.828 16L22.828 24L30.828 32L28 34.828L17.172 24Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowPointLeftCircle);
export default ForwardRef;
